export default "__VITE_ASSET__a17cb4de__"